import { NgModule } from '@angular/core';
//import { TextMaskModule } from 'angular2-text-mask';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

import { ShellModule } from '@sd-portal/shared/shell';
import { SharedUiModule } from '@sd-portal/shared/ui';
import { SharedDirectivesModule } from '@sd-portal/shared/directives';
import { SharedPipesModule } from '@sd-portal/shared/pipes';
import { RefreshTokenService } from './services/refresh-token.service';
import { SharedUtilModule } from './sharedutil.module';
// services
import { BusinessPersonService } from './services/business-person.service';

import { ScreenSizeService } from './services/screen-size.service';
import { ProfileUserSignatureService } from './services/profile-user-signature.service';

// components
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { DialogConfirmComponent } from './components/dialog-confirm/dialog-confirm.component';
import { DurationInputComponent } from './components/duration-input/duration-input.component';
import { LoaderGlobalComponent } from './components/loader-global/loader-global.component';
import { NotesFormControlComponent } from './components/notes-form-control/notes-form-control.component';
import { NotesHoverComponent } from './components/notes-hover/notes-hover.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { RefTypeItemSelectComponent } from './components/reference-type-select/reference-type-select.component';
import { SdLoaderComponent } from './components/sd-loader/sd-loader.component';
import { TimeEditInputComponent } from './components/time-edit-input/time-edit-input.component';
import { TimeInputComponent } from './components/time-input/time-input.component';
import { ToggleGroupComponent } from './components/toggle-group/toggle-group.component';
import { TriOptionConfirmationDialogComponent } from './components/tri-option-confirmation-dialog/tri-option-confirmation-dialog.component';
import { SnackBarNotifierComponent } from './components/snackbar-notifier/snackbar-notifier.component';
import { ValidationMessagesComponent } from './components/validation-messages/validation-messages.component';
import { VendorSelectorComponent } from './components/vendor-selector/vendor-selector.component';
import { ESignatureSignComponent } from './components/esignature-sign/esignature-sign.component';
import { ESignatureRevisionsComponent } from './components/esignature-revisions/esignature-revisions.component';
import { NotesFormStateControlComponent } from './components/notes-formstate-control/notes-formstate-control.component';
import { PromptPersistConfirmDialogComponent } from './components/prompt-persist-confirm-dialog/prompt-persist-confirm-dialog.component';

@NgModule({
  declarations: [
    ConfirmationDialogComponent,
    DialogConfirmComponent,
    DurationInputComponent,
    LoaderGlobalComponent,
    LoaderGlobalComponent,
    LoaderGlobalComponent,
    NotesFormControlComponent,
    NotesFormStateControlComponent,
    NotesHoverComponent,

    RefTypeItemSelectComponent,
    SdLoaderComponent,
    TimeEditInputComponent,
    TimeInputComponent,
    ToggleGroupComponent,
    TriOptionConfirmationDialogComponent,
    SnackBarNotifierComponent,
    ValidationMessagesComponent,
    VendorSelectorComponent,
    ESignatureSignComponent,
    ESignatureRevisionsComponent,
    PromptPersistConfirmDialogComponent
  ],
  imports: [
    SharedPipesModule,
    SharedDirectivesModule,
    SharedUiModule,
    ShellModule,
    NgxMaskDirective,
    SharedUtilModule,
    NgxMaskPipe
  ],
  exports: [
    // lib
    SharedPipesModule,
    SharedDirectivesModule,
    SharedUiModule,
    NgxMaskDirective,
    NgxMaskPipe,
    // components
    ConfirmationDialogComponent,
    DialogConfirmComponent,
    DurationInputComponent,
    LoaderGlobalComponent,
    LoaderGlobalComponent,
    NotesFormControlComponent,
    NotesHoverComponent,
    PaginationComponent,
    RefTypeItemSelectComponent,
    SdLoaderComponent,
    TimeEditInputComponent,
    TimeInputComponent,
    ToggleGroupComponent,
    TriOptionConfirmationDialogComponent,
    SnackBarNotifierComponent,
    ValidationMessagesComponent,
    VendorSelectorComponent,
    ESignatureSignComponent,
    ESignatureRevisionsComponent,
    NotesFormStateControlComponent,
    PromptPersistConfirmDialogComponent
  ],
  providers: [
    BusinessPersonService,
    RefreshTokenService,
    ScreenSizeService,
    ProfileUserSignatureService,
    provideNgxMask()
  ]
})
export class UtilModule {}
